// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ucUBGzS8PqeM5I {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 600px;
}
.ucUBGzS8PqeM5I > button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.ucUBGzS8PqeM5I div {
  display: block;
  text-align: center;
  height: 100%;
}
.ucUBGzS8PqeM5I div h4 {
  font-size: 20px;
  margin: 20px 16px 24px;
}
.ucUBGzS8PqeM5I div p {
  font-size: 16px;
  margin: 0 0 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `ucUBGzS8PqeM5I`
};
export default ___CSS_LOADER_EXPORT___;
